<template>
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17471_95710)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.9997 0.5C14.3267 0.5 0 14.8267 0 32.4997C0 50.1726 14.3267 64.5 31.9997 64.5C49.6726 64.5 64 50.1733 64 32.5003C64 14.8274 49.6726 0.5 31.9997 0.5ZM25.4985 32.4997C25.4985 28.9011 22.5813 25.9839 18.9828 25.9839C15.3842 25.9839 12.467 28.9011 12.467 32.4997C12.467 36.0982 15.3842 39.0154 18.9828 39.0154C22.5813 39.0154 25.4985 36.0982 25.4985 32.4997ZM45.0165 25.9839C48.615 25.9839 51.5322 28.9011 51.5322 32.4997C51.5322 36.0982 48.615 39.0154 45.0165 39.0154C41.4179 39.0154 38.5007 36.0982 38.5007 32.4997C38.5007 28.9011 41.4179 25.9839 45.0165 25.9839Z"
        fill="white"
      />
    </g>

    <defs>
      <clipPath id="clip0_17471_95710">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'ElsklingSymbolWhite'
  }
</script>
